/**
 * Whether AI is worth offering at all, for this signed-in teacher's school.
 *
 * One shared query rather than every editor asking separately: a paper with
 * twenty questions must not fire twenty status requests. A short stale time
 * keeps it fresh enough to notice quota running out mid-session without
 * refetching on every keystroke.
 */

import { useQuery } from '@tanstack/react-query'
import { api } from './api/client'

export function useAiStatus() {
  const query = useQuery({
    queryKey: ['ai', 'status'],
    queryFn: () => api.aiStatus(),
    staleTime: 30_000,
  })
  return (
    query.data ?? {
      grammar_available: false,
      images_available: false,
      reason: null,
      quota_image_remaining: null,
      quota_text_remaining: null,
    }
  )
}
